<template>
  <bm-dialog
    :label="$m.racking_scan_container"
    :visible="value"
    :cancelable="false"
    @cancel="cancel"
  >
    <v-container pa-0 fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <bm-barcode-input
            ref="barcodeTextElement"
            :barcode-types="barcodeTypes"
            :label="$m.racking_enter_label_no_label"
            :rules="[$ruleSet.required()]"
            @input-complete="inputComplete"
          />
        </v-col>
      </v-row>
      <v-row class="pl-1 py-0">
        <v-col cols="12" class="py-0">
          <slot name="additional-information" />
        </v-col>
      </v-row>
    </v-container>
    <template #controls>
      <bm-btn
        block
        button-type="secondary"
        :x-large="xLarge"
        :t="$m.keys.back"
        @click="cancel"
      />
    </template>
  </bm-dialog>
</template>
<script lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmBarcodeInput from "@/components/controls/device/BmBarcodeInput.vue";
import { defineComponent, ref, watch } from "vue";
import { useReactiveDialogSetup } from "@/components/mixins/dialogs";
import { EnumBrewmanBarcodeType } from "@/app/services/generated/enums/enumBrewmanBarcodeType.generated";
import appStore from "@/store/modules/appStore";

export default defineComponent({
  name: "ScanContainerDialog",
  components: { BmDialog, BmBarcodeInput },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    xLarge: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { cancel } = useReactiveDialogSetup(ref(props.value), context);
    const barcodeTextElement = ref(null);

    const barcodeTypes: EnumBrewmanBarcodeType[] = [
      EnumBrewmanBarcodeType.tracking,
    ];

    const inputComplete = (scannedValue: string) => {
      if (scannedValue.length) {
        context.emit("input-complete", scannedValue);
      }
    };

    const getInput: () => HTMLInputElement | undefined = () => {
      const inputElements = (
        ((barcodeTextElement.value as any)?.$refs.barcodeScannerField as any)
          ?.$el as HTMLElement | undefined
      )?.getElementsByTagName("input");

      return inputElements?.length ? inputElements[0] : undefined;
    };

    watch(
      () => appStore.state.loading,
      async () => {
        getInput()?.focus();
      }
    );

    return {
      cancel,
      inputComplete,
      barcodeTypes,
      barcodeTextElement,
    };
  },
});
</script>
